export default __webpack_public_path__ + "static/media/header-logo.f42d2e36.webp";